import { SummaryItem as SummaryItemModel } from 'models/SummaryItem';
import { rm } from 'utils';
import { useSelector } from 'react-redux';
import { SummaryType } from 'models/SummaryType';
import Price from 'components/Shared/Price';
import styles from './styles.scss';
import { selectSummary } from './selector';

export const SummaryItemList = () => {
  const summary = useSelector(selectSummary);

  if (!summary || !summary.items) {
    return null;
  }

  return <>{summary.items.map(summaryItem => SummaryItem({ summaryItem }))}</>;
};

type SummaryItemProps = {
  summaryItem: SummaryItemModel;
};

const SummaryItem = ({ summaryItem }: SummaryItemProps) => {
  const { type, amount, originalAmount, id, description } = summaryItem;
  const isDiscount = type === SummaryType.Discount || type === SummaryType.Saving;
  const isFreightMissing = type === SummaryType.ZipDependantFreight || amount === 0;
  const showOriginalAmount = originalAmount > 0 && originalAmount !== amount;

  if (isFreightMissing) {
    return (
      <div key={id} className={styles.priceRow}>
        <span>{rm('checkout_freight_missing_details_rd3')}</span>
      </div>
    );
  }

  return (
    <div key={id} className={styles.priceRow}>
      <span>{description}</span>
      <span>
        {showOriginalAmount && (
          <>
            <Price price={originalAmount} appearance="lineThrough" />
            &nbsp;
          </>
        )}
        <Price price={amount} appearance={isDiscount ? 'discount' : 'normal'} />
      </span>
    </div>
  );
};
